import React from "react";
import uuid from "react-uuid";
import facebook from '../images/social-network/Facebook-1877F2.svg';
import gmail from '../images/social-network/Gmail-D14836.svg';
import linkedIn from '../images/social-network/LinkedIn-0077B5.svg';
import github from '../images/social-network/github.png';

const About = () => {
  const socialNetwork = [
    
    {
      image: github,
      link: "https://github.com/Samiul-Ahmed-96",
    },

    {
      image: facebook,
      link: "https://www.facebook.com/samiulahmed.anik/",
    },
    {
      image: linkedIn,
      link: "https://www.linkedin.com/in/samiul-ahmed-anik/",
    },
    // {
    //   image: instagram,
    //   link: "https://www.instagram.com/s_a_a_n_i_k/",
    // },
    {
      image: gmail,
      link: "https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=dev.samiulahmed@gmail.com",
    },
   
  ];
  return (
    <div id="aboutMe" className="about-wrapper">
      <div className="section-heading">
        <h4>About Me</h4>
      </div>
      <div className="about-content">
        <p>
        Welcome! I'm your Full Stack virtuoso, I'm a professional Full Stack Web Developer with more than 2 years of professional experience in Web Development. skilled in React JS, Redux-Toolkit, React-Redux, JavaScript (ES6), React Bootstrap, React Router, HTML5, CSS3, Bootstrap5, and am also expert with Express JS and MongoDB. I can build web application focusing on performance, responsiveness/mobile-friendliness, usability, and accessibility. I provide services from minor modifications to complete web application development. I always try to offer more than the client's expectations.
        </p>
      </div>
      <div className="social-network">
        <ul>
          {socialNetwork.map((network) => (
            <li key={uuid()}>
              <a href={network.link} target="_blank" ><img src={network.image} alt={network.image} /></a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default About;
